export default __webpack_public_path__ + "images/DetallesLineasFactura-ES.png";